var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPrimaryFfr = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 20,
  height: 20,
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M4.70605 2.29297C4.31543 1.90234 3.68418 1.90234 3.29355 2.29297C2.90293 2.68359 2.90293 3.31797 3.29355 3.70859L5.83418 6.24922L2.95605 9.12734C1.78418 10.2992 1.78418 12.1992 2.95605 13.3711L6.62793 17.043C7.7998 18.2148 9.6998 18.2148 10.8717 17.043L16.8217 11.0898C17.6998 10.2117 17.6998 8.78672 16.8217 7.90859L12.0904 3.17734C11.2123 2.29922 9.7873 2.29922 8.90918 3.17734L7.2498 4.83359L4.70605 2.29297ZM7.2498 7.66484L8.79355 9.20859C9.18418 9.59922 9.81855 9.59922 10.2092 9.20859C10.5998 8.81797 10.5998 8.18359 10.2092 7.79297L8.66543 6.24922L10.3248 4.58984C10.4217 4.49297 10.5811 4.49297 10.6779 4.58984L15.4092 9.32109C15.5061 9.41797 15.5061 9.57734 15.4092 9.67422L14.0842 10.9992H4.10918C4.15293 10.8305 4.24043 10.6742 4.37168 10.543L7.2498 7.66484Z",
  fill: "#00FF00"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgPrimaryFfr);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "8aba7215cb1b7d7cabf6225854042175.svg";